export class TextManager {
    static getEmailFirstPart(email) {
        return email.split("@")[0];
    }
}

export default TextManager;
